import { Tabs } from 'antd';
import useLite from './liteHooks';
import DocContens from 'src/components/docs/DocContens';
import LiteDemo from './lite-demo/LiteDemo';
import LitePage from './lite-page/LitePage';
import { useHistory, useLocation } from 'react-router-dom';
import { IDocumentMenuItem, IDocumentParams } from 'src/components/docs/type';

const LiteDoc: React.FC<{
    menuList: IDocumentMenuItem[];
    pageProps: IDocumentParams;
    currentValue: string;
}> = props => {
    const { menuList, pageProps, currentValue } = props;
    const history = useHistory();
    const location = useLocation();
    const { activeKey, initTabsParams } = useLite(location, history, pageProps.defaultVersionValue ?? '');
    const { TabPane } = Tabs;

    const currentList = (() => {
        const allList = menuList;
        if (allList[1]) {
            allList[1].children = allList[1].children.slice(0, 6);
        }
        const listObj: {
            apiDoc: IDocumentMenuItem[];
            faq: IDocumentMenuItem[];
            guide: IDocumentMenuItem[];
        } = { apiDoc: [], faq: [], guide: [] };

        const path = window.location.pathname;

        for (const item of allList) {
            if (path.includes('api') && item.title.includes('API')) {
                listObj.apiDoc.push(...item.children);
            } else if (path.includes('faq') && item.title.includes('FAQ')) {
                listObj.faq.push(item.children[0]);
            } else if (
                item.title !== 'API文档' &&
                !item.title.includes('FAQ') &&
                !item.title.includes('训练示例（预览') &&
                !item.title.includes('训练推理示例说明')
            ) {
                listObj.guide.push(item);
            }
        }

        if (path.includes('api')) {
            return listObj.apiDoc;
        } else if (path.includes('faq')) {
            return listObj.faq;
        }
        return listObj.guide;
    })();

    const tabData = [
        {
            tab: '关于Paddle Lite',
            key: 'paddleLite',
            component: <LitePage />
        },
        {
            tab: '使用指南',
            key: 'guide',
            component: <DocContens currentList={currentList} pageProps={pageProps} currentValue={currentValue} />
        },
        {
            tab: '应用实践',
            key: 'demo',
            component: <LiteDemo />
        },
        {
            tab: 'API文档',
            key: 'apiDoc',
            component: <DocContens currentList={currentList} pageProps={pageProps} currentValue={currentValue} />
        },
        {
            tab: '常见问题与解答',
            key: 'faq',
            component: <DocContens currentList={currentList} pageProps={pageProps} currentValue={currentValue} />
        }
    ];

    return (
        <Tabs activeKey={activeKey} onChange={initTabsParams}>
            {tabData.map(item => (
                <TabPane tab={item.tab} key={item.key}>
                    {item.component}
                </TabPane>
            ))}
        </Tabs>
    );
};

export default LiteDoc;
